import { createContext } from 'react';
import { ILayoutContext } from './types';
import { initialLayoutState } from './state';

export const LayoutContext = createContext<ILayoutContext>({
  state: initialLayoutState,
  dispatch: () => null,
});
